import { IRoute } from '../../utils/navigation/routes';
import CustomerVerification from './Onboarding/CustomerVerification';
import CustomerVerificationCallback from './Onboarding/CustomerVerificationCallback';
import CustomerVerificationCallback2 from './Onboarding/CustomerVerificationCallback2';
import CustomerVerificationCallbackNoClient from './Onboarding/CustomerVerificationCallbackNoClient';
import CustomerVerificationNoClient from './Onboarding/CustomerVerificationNoClient';
import FeedbackCustomerVerification from './Onboarding/feedback';
import ContactInfoVerification from './Otp/contactInfoVerification';
import ContactInfoVerificationOTP from './Otp/contactInfoVerification/contactInfoVerificationOTP';
import FeedbackOTP from './Otp/contactInfoVerification/contactInfoVerificationOTP/feedbackOTP';
import ContactInfoVerificationStep1 from './Otp/contactInfoVerification/contactInfoVerificationStep1';
import FeedbackContactVerification from './Otp/contactInfoVerification/contactInfoVerificationStep1/feedbackContactVerification';
import ContactInfoVerified from './Otp/contactInfoVerified';
import FeedbackOTPProcess from './Otp/contactInfoVerified/feedbackOTPProcess';

export const escalationRoutes: IRoute[] = [
    //Flujo DAON
    { path: '/customer-verification', element: <CustomerVerification /> },
    { path: '/customer-verification/callback', element: <CustomerVerificationCallback /> },
    { path: '/customer-verification/callback/v2', element: <CustomerVerificationCallback2 /> },
    { path: '/customer-verification-no-client', element: <CustomerVerificationNoClient /> },
    { path: '/customer-verification/callback/no-client', element: <CustomerVerificationCallbackNoClient /> },
    { path: '/customer-verification/feedback', element: <FeedbackCustomerVerification /> },
    { path: '/obd/verify', element: <ContactInfoVerification /> },
    { path: '/obd/verify/contacts', element: <ContactInfoVerificationStep1 /> },
    { path: '/obd/verify/feedback', element: <FeedbackContactVerification /> },
    { path: '/obd/verify/otp', element: <ContactInfoVerificationOTP /> },
    { path: '/obd/verify/otp/feedback', element: <FeedbackOTP /> },
    // FLUJO OTP
    { path: '/escalation/otp', element: <ContactInfoVerified /> },
    { path: '/escalation/otp/feedback', element: <FeedbackOTPProcess /> },
];
